export const checkOverridingInjection = () => {
  let overridingInjections = [];

  if (typeof window !== "undefined") {
    if (window.ethereum) {
      if ((window.ethereum as any).isSafePal) {
        overridingInjections.push("SafePal Wallet");
      }

      if ((window.ethereum as any).isMathWallet) {
        overridingInjections.push("Math Wallet");
      }

      if ((window.ethereum as any).isTrustWallet) {
        overridingInjections.push("Trust Wallet");
      }

      if ((window.ethereum as any).isPhantom) {
        overridingInjections.push("Phantom Wallet");
      }
    }
  }

  return overridingInjections;
};
